import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Container, Col } from "reactstrap";
import { CanView } from '../utils/checkRoles';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { CheckToken } from '../utils/globalService';
import AuthActions from '../store/global/AccountingActions';
import DrawerActions from '../components/Drawer/DrawerActions';
// import Loader from '../components/Loader/loader'
import Header from './Header';
import Drawer from "../components/Drawer";
import SideBar from "./SideBar/SideBar";


//Pages
import Notfound from '../pages/404'
import LoginPage from '../pages/Login';
import Panel from '../pages/Panel';
import Foods from '../pages/Food';
import WeeklyProgram from '../pages/Food/weeklyProgram';
import Users from '../pages/Users';

const MainContainer = ({ isAuthorize, AuthActions, DrawerActions, drawerState, isDrawerFix }) => {
    function reAuth() {
        CheckToken().then(res => {
            if (res.status === 200) {
                AuthActions.setAuth()
                setTimeout(() => {
                    DrawerActions.openDrawer()
                    DrawerActions.toggleDrawerPin()
                    DrawerActions.toggleDrawerFix()
                }, 1000);
            } else {
                AuthActions.setUnAuth()
            }
        }).catch(err => {
            AuthActions.setUnAuth()
        })
    }

    useEffect(() => {
        reAuth()
    }, [])
    const renderRoutes = () => {
        if (isAuthorize) {
            return (
                <>
                    <Header />
                    <Container fluid>
                        <Drawer title="منوی کاربری">
                            <SideBar />
                        </Drawer>
                        <Col
                            xs="12"
                            style={{ paddingTop: 10 }}
                            className={`mainCt ${drawerState
                                ? !isDrawerFix
                                    ? "withDrawer"
                                    : ""
                                : ""
                                }`}
                        >
                            <Switch>
                                <Route path="/" exact component={Panel} />
                                <Route path="/foods" exact component={Foods} />
                                <Route path="/foods/program" exact component={WeeklyProgram} />
                                <CanView role={2}>
                                    <Route path="/users" exact component={Users} />
                                </CanView>
                                <Route path='*' component={Notfound} />
                            </Switch>
                        </Col>
                    </Container>
                </>
            )
        }
        return (
            <Route path="*" component={LoginPage} />
        )
    }
    return (
        <Router>
            {/* <Header /> */}
            {/* <Loader /> */}
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
            {renderRoutes()}
        </Router>
    )

}

function mapDispatchToProps(dispatch) {
    return {
        AuthActions: AuthActions(dispatch),
        DrawerActions: DrawerActions(dispatch)
    }
}
const MapStateToProps = (state) => {
    return {
        isAuthorize: state.handleAuth.isAuthorize,
        drawerState: state.handleDrawer.isDrawerOpen,
        isDrawerFix: state.handleDrawer.isDrawerFix,
    }
};

export default connect(MapStateToProps, mapDispatchToProps)(MainContainer)
